import { MenuItem, Select } from "@mui/material";

// Countries a customer can log in from in the user app (same list and lengths as auth/otp).
export const PHONE_COUNTRIES = [
  { code: "91", name: "India", length: 10 },
  { code: "1", name: "USA", length: 10 },
  { code: "971", name: "UAE", length: 9 },
];

export const phoneLength = (code) =>
  PHONE_COUNTRIES.find((c) => c.code === String(code))?.length ?? 10;

// Keeps digits only, up to the country's length.
export const cleanPhone = (value, code) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, phoneLength(code));

// "+971 501234567" / "+971501234567" → { code: "971", number: "501234567" }.
// Old values saved without a code (e.g. "98765-43210") are treated as India.
export const splitPhone = (value) => {
  const raw = String(value ?? "").replace(/[^\d+]/g, "");
  for (const c of PHONE_COUNTRIES) {
    if (raw.startsWith("+" + c.code)) {
      return { code: c.code, number: cleanPhone(raw.slice(c.code.length + 1), c.code) };
    }
  }
  return { code: "91", number: raw.replace(/\D/g, "").slice(-10) };
};

// Compact country code picker: the field shows "+91 ▾", the menu lists "India  +91".
// Borderless so it sits inside the existing white input boxes.
export const CountryCodeSelect = ({ value, onChange, sx }) => (
  <Select
    variant="standard"
    disableUnderline
    value={value}
    onChange={(e) => onChange(e.target.value)}
    renderValue={(v) => `+${v}`}
    sx={{
      fontSize: "13.5px",
      fontWeight: "500",
      "& .MuiSelect-select": {
        py: 0,
        pl: "0.5rem",
        "&:focus": { bgcolor: "transparent" },
      },
      ...sx,
    }}
  >
    {PHONE_COUNTRIES.map((c) => (
      <MenuItem
        key={c.code}
        value={c.code}
        sx={{
          fontSize: "13px",
          minWidth: "9rem",
          display: "flex",
          justifyContent: "space-between",
          gap: "1.5rem",
        }}
      >
        <span>{c.name}</span>
        <span style={{ color: "#7A7A7A" }}>+{c.code}</span>
      </MenuItem>
    ))}
  </Select>
);
